import React from 'react';
import PropTypes from 'prop-types';

import { Container, Badge } from './styles';
import { Tooltip } from '../../popovers';

function TaskPriority({ priority, withTitle, withMargin }) {
  return (
    <Container>
      <Tooltip
        placement="bottomLeft"
        title={withTitle ? null : priority && priority.label}
      >
        <Badge
          color={priority && priority.color}
          withMargin={withMargin && withTitle}
        />
      </Tooltip>
      {withTitle && priority && priority.label}
    </Container>
  );
}

TaskPriority.propTypes = {
  withTitle: PropTypes.bool,
  withMargin: PropTypes.bool,
  priority: PropTypes.object.isRequired,
};

TaskPriority.defaultProps = {
  withTitle: true,
  withMargin: true,
};

export default TaskPriority;



// WEBPACK FOOTER //
// ./src/components/task-item/task-priority/index.js